/**
 * Owner: Masa Bayu
 * File: script-codes.ts
 * Date:Time: 2026-09-20 00:59
 * Description: Script direction metadata enums — Batch 7 regional families.
 */
/** Metadata only — not RTL rendering / bidi behaviour (those are GL-03). */
export const QX_SCRIPT_DIRECTIONS = ['ltr', 'rtl', 'auto'];
export const QX_SCRIPT_MODEL_VERSION = '1.0.0';
export const QX_SCRIPT_FAMILY_IDS = [
    'latin',
    'arabic',
    'hebrew',
    'cyrillic',
    'greek',
    'cjk',
    'indic',
    'thai',
    'lao',
    'khmer',
    'myanmar',
    'armenian',
    'georgian',
    'ethiopic',
    'tibetan',
    'other',
];
export function isQxScriptDirection(value) {
    return (typeof value === 'string' &&
        QX_SCRIPT_DIRECTIONS.includes(value));
}
export function isQxScriptFamilyId(value) {
    return (typeof value === 'string' &&
        QX_SCRIPT_FAMILY_IDS.includes(value));
}
//# sourceMappingURL=script-codes.js.map